// A disclosure cannot contain interactions, arbitrary URLs or another disclosure.
function requireValue(ok) { if (!ok) throw new Error('INVALID_DETAIL_VIEW') }
const identifier = value => typeof value === 'string' && /^[0-9]{1,20}$/.test(value)
export function validateDetailContent(card, paged = false) {
  requireValue(new TextEncoder().encode(JSON.stringify(card)).length <= 65536)
  requireValue(card && ['action_list', 'device_cards', 'scene_cards', 'info_list'].includes(card.type) && card.version === 1)
  requireValue(!card.interaction && (paged || card.hasMore !== true) && Array.isArray(card.items) && (paged || card.items.length <= 60))
  requireValue(typeof card.title === 'string' && card.title.length <= 100)
  if (card.type === 'info_list') requireValue(['rooms','scenes','statistics'].includes(card.kind))
  const ids = new Set()
  for (const item of card.items) {
    requireValue(item && (card.type === 'info_list' ? typeof item.label === 'string' && typeof item.value === 'string' : typeof item.title === 'string'))
    const id = card.type === 'scene_cards' ? item.ref && item.ref.sceneId : card.type === 'device_cards' ? item.ref && [item.ref.regionId,item.ref.productId,item.ref.deviceId].join(':') : card.type === 'info_list' ? item.id : item.itemRef
    requireValue(!ids.has(id)); ids.add(id)
    if (card.type === 'device_cards') {
      requireValue(item.ref && identifier(item.ref.deviceId) && identifier(item.ref.regionId) && identifier(item.ref.productId))
      if (item.preview) requireValue(item.preview.deviceId === item.ref.deviceId && item.preview.regionId === item.ref.regionId && item.preview.productId === item.ref.productId)
    }
    else if (card.type === 'scene_cards') requireValue(item.ref && identifier(item.ref.sceneId) && item.preview && item.preview.sceneId === item.ref.sceneId)
    else if (card.type === 'info_list') requireValue(typeof item.id === 'string' && item.id.length > 0 && !item.interaction)
    else requireValue(typeof item.itemRef === 'string' && !item.interaction && (!item.result || ['SUCCEEDED','ACCEPTED','FAILED','UNKNOWN','CANCELLED','EXPIRED'].includes(item.result.state)))
  }
  if (card.type === 'scene_cards' && card.source) requireValue(card.source.kind === 'scene_read' || (card.source.kind === 'action_scenes' && validSource(card.source)))
  return card
}
export function validateDetailViews(card) {
  requireValue(card.mode === 'single' && Array.isArray(card.entries) && card.entries.length > 0 && card.entries.length <= 4)
  const ids = new Set()
  for (const entry of card.entries) {
    requireValue(entry && typeof entry.id === 'string' && !ids.has(entry.id)); ids.add(entry.id)
    requireValue(typeof entry.label === 'string' && entry.label.length <= 40 && typeof entry.collapseLabel === 'string' && entry.collapseLabel.length <= 40)
    requireValue(!!entry.content !== !!entry.source)
    if (entry.content) validateDetailContent(entry.content)
    else requireValue(validSource(entry.source))
  }
}

function validSource(source) { return ['action_devices','action_scenes'].includes(source.kind) && identifier(source.sessionId) && identifier(source.turnId) && identifier(source.actionId) }
